import React, { useCallback, useEffect, useState } from 'react';
import {
  Button,
  Card,
  Col,
  Form,
  Input,
  Modal,
  Row,
  Space,
  Table,
  Tabs,
  Typography,
} from 'antd';
import type { ColumnsType } from 'antd/es/table';
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
import moment from 'moment';

import {
  FormLabel,
  Loading,
  ScreenMask,
  message,
} from 'components/common';
import { LOADING_ICON_SIZE1 } from 'constants/config';
import { loadProductCodeQuatity } from 'services/product';
import { leaveEditForm, playSound } from 'utils';
import { ScanRecvSkuType } from '.';

const { Text } = Typography;
type Props = {
  onHide: () => void;
  onSubmit: (
    items: { [key: string]: any },
    data: any[],
    str: string,
    tab: string
  ) => void;
  defaultData: string[];
  defaultStr: string;
  skuList: ScanRecvSkuType[];
  defaultTab: string;
};

// eslint-disable-next-line
export default (props: Props) => {
  const { onHide, onSubmit, defaultData, skuList, defaultStr, defaultTab } =
    props;
  const [data, setData] = useState<any[]>(defaultData);
  const [data2, setData2] = useState<any[]>([]);
  const [lockScreen, setLockScreen] = useState(false);
  const [scannerInputVersion, setScannerInputVersion] = useState(0);
  const [selectedTab, setSelectTab] = useState<string>(defaultTab);
  const [str, setStr] = useState(defaultStr);
  const [lastScan, setLastScan] = useState<{
    sku: string;
    time: string;
  }>();
  const [form] = Form.useForm();

  // const checkStr = useCallback((str: string) => {
  //   const temp = str.split('\n');
  //   const tempArr: any[] = [];
  //   let arr: string[] = [];
  //   temp.map((i) => {
  //     if (i) {
  //       if (arr.indexOf(i) === -1) {
  //         arr.push(i);
  //         tempArr.push({
  //           sku: i,
  //           qty: 1,
  //         });
  //       } else {
  //         tempArr[arr.indexOf(i)] = {
  //           sku: i,
  //           qty: tempArr[arr.indexOf(i)].qty + 1,
  //         };
  //       }
  //       return true;
  //     } else {
  //       return true;
  //     }
  //   });
  //   setData2(tempArr);
  //   return tempArr;
  // }, []);

  const checkStr2 = useCallback(async (str: string) => {
    const temp = str.split('\n');
    const tempArr: any[] = [];
    let arr: string[] = [];
    const codeMap: Record<string, { sku: string; qty: number }> = {};
    if (temp.length > 0) {
      const res = await loadProductCodeQuatity(temp);
      if (res && res.isSuccess) {
        if (res.data && res.data.length > 0) {
          res.data.map((i: any) => {
            codeMap[i.code] = { sku: i.sku, qty: i.code === i.sku ? 1 : i.qty };
            return true;
          });
        }
      }
      temp.map((i) => {
        if (i) {
          if (codeMap[i]) {
            if (arr.indexOf(codeMap[i].sku) === -1) {
              arr.push(i);
              tempArr.push({
                sku: codeMap[i].sku,
                qty: codeMap[i].qty,
              });
            } else {
              tempArr[arr.indexOf(codeMap[i].sku)] = {
                sku: codeMap[i].sku,
                qty: tempArr[arr.indexOf(codeMap[i].sku)].qty + codeMap[i].qty,
              };
            }
          } else {
            if (arr.indexOf(i) === -1) {
              arr.push(i);
              tempArr.push({
                sku: i,
                qty: 1,
              });
            } else {
              tempArr[arr.indexOf(i)] = {
                sku: i,
                qty: tempArr[arr.indexOf(i)].qty + 1,
              };
            }
          }
          return true;
        } else {
          return true;
        }
      });

      setData2(tempArr);
      return tempArr;
    } else {
      setData2([]);
      return [];
    }
  }, []);

  /**
   * handle submit event
   */
  const handleSubmit = useCallback(async () => {
    let items: { [key: string]: any } = {};
    if (selectedTab === 'single') {
      data.map((i) => {
        //items[i.sku] = i.qty;
        items[i.sku] = {
          qty: i.qty,
          baseQty: i.baseQty,
          uom: i.uom,
          uomRate: i.uomRate,
          upc: i.upc,
        };
        return true;
      });
    } else {
      const t = await checkStr2(str);
      t.map((i) => {
        const index = skuList.findIndex(
          (j) => j.sku === i.sku || j.upc === i.sku
        );
        if (index > -1) {
          items[skuList[index].sku] = {
            qty: items[skuList[index].sku]
              ? items[skuList[index].sku] + i.qty
              : i.qty,
            baseQty: i.baseQty,
            uom: i.uom,
            uomRate: i.uomRate,
            upc: i.upc,
          };
        }
        return true;
      });
    }
    onSubmit(items, data, str, selectedTab);
  }, [onSubmit, data, str, selectedTab, skuList, checkStr2]);
  /**
   * handle cancel event
   */
  const handleCancel = useCallback(async () => {
    const cancel = await leaveEditForm({}, form);
    if (cancel) {
      onHide();
    }
  }, [onHide, form]);

  useEffect(() => {
    if (defaultStr) {
      checkStr2(defaultStr);
    }
  }, [defaultStr, checkStr2]);

  const onKeyDown = async (evt: any) => {
    if ([9, 13].indexOf(evt.keyCode) > -1) {
      form.setFieldsValue({
        scanValue: undefined,
      });
      evt.preventDefault();

      if (evt.target.value) {
        const newValue = `${evt.target.value}`;
        const idx = skuList.findIndex(
          (i) => i.sku === newValue || i.upc === newValue
        );

        if (idx > -1) {
          const index = data.findIndex((i) => i.sku === skuList[idx].sku);
          //console.log('idx', index, skuList[idx], skuList);
          if (index > -1) {
            const temp = [...data];

            if (temp[index].uom !== skuList[idx].uom) {
              const msg = `The UOM[${skuList[idx].uom}] of "${newValue}" is different from the previous one[${temp[index].uom}]`;
              playSound('error');
              Modal.error({
                centered: true,
                content: msg,
                title: 'Different UOM',
                onOk() {
                  setScannerInputVersion(scannerInputVersion + 1);
                },
              });
              return;
            }

            temp[index] = {
              sku: skuList[idx].sku,
              uom: skuList[idx].uom,
              uomBaseQty: skuList[idx].uomBaseQty,
              uomRate: skuList[idx].uomRate,
              upc: skuList[idx].upc,
              qty: temp[index].qty + 1,
              baseQty: temp[index].baseQty + skuList[idx].uomRate * 1,
            };
            setData([...temp]);
          } else {
            setData([
              {
                sku: skuList[idx].sku,
                uom: skuList[idx].uom,
                uomBaseQty: skuList[idx].uomBaseQty,
                uomRate: skuList[idx].uomRate,
                upc: skuList[idx].upc,
                qty: 1,
                baseQty: skuList[idx].uomRate * 1,
              },
              ...data,
            ]);
          }
          playSound('bell');
          setLastScan({
            sku: newValue,
            time: moment().format('hh:mm:ssA'),
          });
        } else {
          let res: any = null;
          try {
            setLockScreen(true);
            // load product code info
            res = await loadProductCodeQuatity([newValue]);
          } catch(e) {
            message.error(`Loaded product code quantity error: ${e}`);
          } finally {
            setLockScreen(false);
          }
          if (res && res.isSuccess) {
            if (res.data && res.data.length > 0) {
              // eslint-disable-next-line
              const { sku, qty: qqty, uom, uomrate: uomRate } = res.data[0];
              const idx2 = skuList.findIndex((i) => i.sku === sku);

              if (idx2 > -1) {
                const index2 = data.findIndex(
                  (i) => i.sku === skuList[idx2].sku
                );
                if (index2 > -1) {
                  const temp = [...data];

                  console.log('sl', temp[index2].uom, skuList[idx2].uom);
                  if (temp[index2].uom !== uom) {
                    const msg = `The UOM[${uom}] of "${newValue}" is different from the previous one[${temp[index2].uom}]`;
                    playSound('error');
                    Modal.error({
                      centered: true,
                      title: 'Different UOM',
                      content: msg,
                      onOk() {
                        setScannerInputVersion(scannerInputVersion + 1);
                      },
                    });
                    return;
                  }

                  temp[index2] = {
                    sku: skuList[idx2].sku,
                    upc: skuList[idx2].upc,
                    //qty: temp[index2].qty + qqty,
                    qty: temp[index2].qty + 1,
                    uom: uom,
                    //baseQty: temp[index2].baseQty + uomRate * qqty,
                    baseQty: temp[index2].baseQty + uomRate * 1,
                    uomRate,
                  };
                  setData([...temp]);
                } else {
                  setData([
                    {
                      sku: skuList[idx2].sku,
                      upc: skuList[idx2].upc,
                      //qty: qqty,
                      qty: 1,
                      uom: uom,
                      //baseQty: uomRate * qqty,
                      baseQty: uomRate * 1,
                      uomRate,
                    },
                    ...data,
                  ]);
                }

                playSound('bell');
                setLastScan({
                  sku: newValue,
                  time: moment().format('hh:mm:ssA'),
                });
              } else {
                playSound('error');
                message.error(`[${newValue}] not found`);
              }
            } else {
              playSound('error');
              message.error(`[${newValue}] not found`);
            }
          } else {
            playSound('error');
            message.error(`[${newValue}] not found`);
          }
        }
      }
    }
  };

  const renderTabelCellByIndex = (idx: number, text: any) => {
    return idx > -1 ? (
        <Text>{text}</Text>
      ) : (
        <Text style={{ color: '#ff4d4f' }} delete>
          {text}
        </Text>
      );
  };

  const columns: ColumnsType<any> = [
    {
      title: 'SKU',
      dataIndex: 'sku',
      key: 'sku',
      render: (text) =>
        skuList.findIndex((i) => i.sku === text) > -1 ? (
          <Text>{text}</Text>
        ) : (
          <Text style={{ color: '#ff4d4f' }} delete>
            {text}
          </Text>
        ),
    },
    {
      title: 'UPC',
      dataIndex: 'upc',
      key: 'upc',
      render: (text, record) =>
        skuList.findIndex((i) => i.sku === record.sku) > -1 ? (
          <Text>{text}</Text>
        ) : (
          <Text style={{ color: '#ff4d4f' }} delete>
            {text}
          </Text>
        ),
    },
    {
      title: 'UOM',
      dataIndex: 'uom',
      key: 'uom',
      width: 100,
      render(text, record) {
        /*const idx = skuList.findIndex((i) => i.uom === record.uom);
        let t = text;

        if (idx > -1) {
          //console.log('t', idx, text, record);
          t = `${text}(${record.uomRate})`;
        }

        return renderTabelCellByIndex(idx, t);*/
        const  t = `${text}(${record.uomRate})`;

        return renderTabelCellByIndex(0, t);
      },
    },
    /*{
      align: 'right',
      title: 'UOM Rate',
      dataIndex: 'uomRate',
      key: 'uomRate',
      width: 100,
      render(text, record) {
        const idx = skuList.findIndex((e) => e.uomRate === record.uomRate);

        return renderTabelCellByIndex(idx, text);
      },
    },*/
    {
      align: 'right',
      title: 'Qty',
      dataIndex: 'qty',
      key: 'qty',
      width: 100,
      render: (text, record) =>
        skuList.findIndex((i) => i.sku === record.sku) > -1 ? (
          <Text>{text}</Text>
        ) : (
          <Text style={{ color: '#ff4d4f' }} delete>
            {text}
          </Text>
        ),
    },
    {
      align: 'right',
      title: 'Base Qty',
      dataIndex: 'baseQty',
      key: 'baseQty',
      width: 100,
      render(text, record) {
        /*const idx = skuList.findIndex((e: any) => e.baseQty === record.baseQty);
        let t = '';

        if (idx > -1 && typeof record.qty === 'number' && typeof record.uomRate === 'number') {
          t = `${record.uomRate * record.qty}`;
        }

        return renderTabelCellByIndex(idx, text);*/
        return renderTabelCellByIndex(0, text);
      },
    },
  ];

  const columns2: ColumnsType<any> = [
    {
      title: 'SKU / UPC',
      dataIndex: 'sku',
      key: 'sku',
      render: (text) =>
        skuList.findIndex((i) => i.sku === text || i.upc === text) > -1 ? (
          <Text>{text}</Text>
        ) : (
          <Text style={{ color: '#ff4d4f' }} delete>
            {text}
          </Text>
        ),
    },
    {
      title: 'Qty',
      dataIndex: 'qty',
      key: 'qty',
      render: (text, record) =>
        skuList.findIndex((i) => i.sku === record.sku || i.upc === record.sku) >
        -1 ? (
          <Text>{text}</Text>
        ) : (
          <Text style={{ color: '#ff4d4f' }} delete>
            {text}
          </Text>
        ),
    },
  ];

  return (<>
    <Modal
      title="Scan to Recieve"
      centered
      visible={true}
      width={800}
      destroyOnClose={true}
      onCancel={handleCancel}
      footer={
        <Row justify="end">
          <Space>
            <Button
              key="submit"
              type="primary"
              onClick={handleSubmit}
              icon={<CheckOutlined />}
            >
              Continue
            </Button>
            <Button onClick={handleCancel} icon={<CloseOutlined />}>
              Cancel
            </Button>
          </Space>
        </Row>
      }
    >
      <Form form={form}>
        <Tabs activeKey={selectedTab} onChange={setSelectTab}>
          <Tabs.TabPane tab="Single Scan" key="single">
            <Card
              title={
                <Row justify="space-between">
                  <Space>
                    <FormLabel>Scan SKU / UPC</FormLabel>
                    <Form.Item noStyle name="scanValue">
                      <Input
                        allowClear
                        autoFocus
                        onKeyDown={onKeyDown}
                        style={{ width: 200 }}
                        key={`scan-input-${scannerInputVersion}`}
                      />
                    </Form.Item>
                  </Space>
                  {lastScan && (
                    <Row>
                      <Space>
                        <Typography.Text
                          style={{ fontSize: 12 }}
                          type="secondary"
                        >{`Last scan: ${lastScan.sku}`}</Typography.Text>
                        <Typography.Text
                          style={{ fontSize: 12 }}
                          type="secondary"
                        >{`Scanned time: ${lastScan.time}`}</Typography.Text>
                      </Space>
                    </Row>
                  )}
                </Row>
              }
            >
              <Table
                rowKey="sku"
                scroll={{ y: 240 }}
                dataSource={data}
                columns={columns}
                pagination={false}
              />
            </Card>
          </Tabs.TabPane>
          <Tabs.TabPane tab="Paste Multiple" key="multiple">
            <Row>
              <Col span={12}>
                <Space direction="vertical">
                  <Input.TextArea
                    style={{ width: 350 }}
                    rows={16}
                    value={str}
                    onChange={(e) => setStr(e.target.value)}
                  />
                  <Button
                    onClick={() => {
                      checkStr2(str);
                    }}
                  >
                    Check
                  </Button>
                </Space>
              </Col>
              <Col span={12}>
                <Table
                  rowKey="sku"
                  scroll={{ y: 322 }}
                  dataSource={data2}
                  columns={columns2}
                  pagination={false}
                />
              </Col>
            </Row>
          </Tabs.TabPane>
        </Tabs>
      </Form>
    </Modal>
    {lockScreen && (
      <ScreenMask>
        <Loading size={LOADING_ICON_SIZE1} />
      </ScreenMask>
    )}
  </>);
};
